import { render, staticRenderFns } from "./multilingual.vue?vue&type=template&id=109b11a4&"
import script from "./multilingual.vue?vue&type=script&lang=js&"
export * from "./multilingual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports